@let selectedWidgetAlias = selectedWidgetAliasSg();
@let editingWidgetFrameId = store.editingWidgetFrameIdSg();

@if (editingWidgetFrameId) {
  <atn-ds-centered-overlay type="full-width">
    <div class="atn-widget-selector">
      <atn-ds-widget title="Select Widget">
        <div actions>
          <i
            class="atn-icon atn-close atn-red"
            (click)="cancelClickHandler()"
          ></i>
        </div>
        <div class="atn-widget-selector__selection">
          <atn-ds-select-single-ec
            [collection]="widgetEc"
            [config]="{
              overlay: {
                hasSearch: true,
              },
            }"
            [selectionTarget]="store.widgetSelectionTarget"
            descriptor="WidgetSelector.Overlay"
          />
        </div>
        <div class="atn-widget-selector__preview">
          @if (selectedWidgetAlias) {
            @let widgetPreview = widgetPreviewSg();
            @let isLoading =
              !!widgetPreviewPlugin.feature.selectors
                .getWidgetLoading({
                  alias: selectedWidgetAlias,
                })
                .asSignal();

            <atn-mosaic-widget
              [refId]="selectedWidgetAlias"
              [loading]="isLoading"
              [rendering]="widgetPreview"
            />
          }
        </div>
        <div
          class="atn-widget-selector__footer"
          footer
        >
          <atn-ds-button
            type="transparent"
            (click)="cancelClickHandler()"
          >
            Cancel
          </atn-ds-button>
          <atn-ds-button (click)="saveClickHandler()"> Save </atn-ds-button>
        </div>
      </atn-ds-widget>
    </div>
  </atn-ds-centered-overlay>
}
